import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/student/home/HeroSection.css';
import { FaCheck, FaGraduationCap, FaBook, FaTrophy, FaPencilAlt } from "react-icons/fa";
import heroPic1 from "../../../assets/images/home/heroPic1.jpg";
import heroPic2 from "../../../assets/images/home/heroPic2.jpg";
import heroPic3 from "../../../assets/images/home/heroPic3.jpg";
import heroPic4 from "../../../assets/images/home/heroPic4.jpg";

const HeroSection = () => {
  const navigate = useNavigate();
  const [currentWord, setCurrentWord] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);

  const words = ['futures', 'hope', 'dreams', 'minds'];

  const slides = [
    {    
       image: heroPic1,
      // image: 'https://t3.ftcdn.net/jpg/09/28/53/10/360_F_928531048_45ay4GSNYJuTLIHKtuR255O9ndjsHg5x.jpg',
      alt: 'Students studying together'
    },
    {
      image: heroPic2,
      // image: 'https://upload.wikimedia.org/wikipedia/commons/8/8e/Staples_High_School%2C_Westport%2C_CT.jpg',
      alt: 'Happy students learning'
    },
    {
      image: heroPic3,
      // image: 'https://media.istockphoto.com/id/1498878143/photo/book-stack-and-open-book-on-the-desk-in-modern-public-library.jpg?s=612x612&w=0&k=20&c=vRcxdgfHSFJkow6DNPtaL9DT_ttdMGWel-qRLEzkQEI=',
      alt: 'Education support'
    },
    {
      image: heroPic4,
      // image: 'https://helixintel.com/wp-content/uploads/2023/09/1610-003S.jpg',
      alt: 'Students receiving support'
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWord(prev => (prev + 1) % words.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // FIXED: Corrected handleDonateClick function
  // const handleDonateClick = () => {
  //   const token = localStorage.getItem('donor_token');
    
  //   // If user is already logged in, redirect to dashboard
  //   if (token) {
  //     navigate('/donor/dashboard');
  //   } else {
  //     // If not logged in, redirect to login page
  //     navigate('/donor/login');
  //   }
  // };
// const handleDonateClick = () => {
//   const token = localStorage.getItem("donorToken");

//   console.log("Donor Token:", token); // debugging

//   if (!token || token === "undefined" || token === "null" || token === "") {
//     navigate("/donor/login");
//   } else {
//     navigate("/donor/dashboard");
//   }
// };



const handleDonateClick = () => {
  navigate("/donor/login"); // apna donor login route
};

  return (
    <section className="hero-section-slider"> 
      
      {/* Background Slider Images */}
      <div className="hero-slider-container">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentSlide ? 'hero-active' : ''} ${
              index === (currentSlide - 1 + slides.length) % slides.length ? 'hero-prev' : ''
            }`}
          >
            <img src={slide.image} alt={slide.alt} />
          </div>
        ))}
      </div>

      <div className="hero-overlay"></div>

      {/* Educational Floating Icons */}
      <div className="hero-floating-icons">
        <div className="hero-floating-icon hero-icon-1">
          <FaGraduationCap />
        </div>
        <div className="hero-floating-icon hero-icon-2">
          <FaBook />
        </div>
        <div className="hero-floating-icon hero-icon-3">
          <FaTrophy />
        </div>
        <div className="hero-floating-icon hero-icon-4">
          <FaPencilAlt />
        </div>
        <div className="hero-floating-icon hero-icon-5">
          <FaGraduationCap />
        </div>
        <div className="hero-floating-icon hero-icon-6">
          <FaBook />
        </div>
      </div>

      <div className="hero-content-center">
        
        {/* Main Heading with rotating word */}
        <h1 className="hero-heading-center hero-fade-in">
          <span className="hero-fixed-text">Empower </span>
          <span className="hero-rotating-word-wrapper">
            <span key={currentWord} className="hero-rotating-word-center">
              {words[currentWord]}
            </span>
          </span>
          <br />
          <span className="hero-second-line">change lives today</span>
        </h1>

        {/* Subheading */}
        <p className="hero-subheading-center hero-fade-in-delay">
          Shape a brighter future and building a better world with our impactful student support initiatives.
        </p>

        {/* CTA Button */}
        <div className="hero-cta-section-center hero-fade-in-delay-2">
          <button
            className="hero-donate-btn-center hero-pulse-btn"
            onClick={handleDonateClick}
          >
          <span className="hero-btn-text">Donate now</span>
          <span className="hero-btn-arrow">→</span>
          </button>
        </div>
       

        {/* Categories */}
        <div className="hero-categories-center hero-fade-in-delay-3">
          <div className="hero-category-item-center">
            <FaCheck className="hero-check-icon-center" />
            <span>Fee</span>
          </div>
          <div className="hero-category-item-center">
            <FaCheck className="hero-check-icon-center" />
            <span>Uniform</span>
          </div>
          <div className="hero-category-item-center">
            <FaCheck className="hero-check-icon-center" />
            <span>Books</span>
          </div>
        </div>
      </div>

      {/* Floating Particles */}
      <div className="hero-particle hero-particle-1"></div>
      <div className="hero-particle hero-particle-2"></div>
      <div className="hero-particle hero-particle-3"></div>
      <div className="hero-particle hero-particle-4"></div>
      
    </section>
  );
};

export default HeroSection;

    



